import {
  getPatientByIdFailure,
  getPatientByIdLoading,
  getPatientByIdSuccess,
  getPatientFailure,
  getPatientLoading,
  getPatientSuccess,
  updatePatientFailure,
  updatePatientLoading,
  updatePatientSuccess,
} from "@redux/slices/patientSlice";
import { getPatient } from "@services/patient/getPatient";
import { getPatientByid } from "@services/patient/getPatientById";
import { updatePatient } from "@services/patient/updatePatient";
import { useDispatch } from "react-redux";
import getErrorStatement from "src/utils/getErrorStatement";
import { notify } from "src/utils/notify";

const usePatient = () => {
  const dispatch = useDispatch();

  const handleGetPatient = async (searchFilters) => {
    try {
      dispatch(getPatientLoading());
      const response = await getPatient(searchFilters);
      dispatch(getPatientSuccess(response.data));
    } catch (error) {
      dispatch(getPatientFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleGetPatientById = async (email) => {
    try {
      dispatch(getPatientByIdLoading());
      const response = await getPatientByid(email); // Assuming getPatient service can also fetch by ID
      dispatch(getPatientByIdSuccess(response.data));
    } catch (error) {
      dispatch(getPatientByIdFailure());
      notify(getErrorStatement(error));
    }
  };

  const handleUpdatePatient = async (
    patientId,
    updatedData,
    onSuccess = null
  ) => {
    try {
      dispatch(updatePatientLoading());
      const response = await updatePatient(patientId, updatedData);
      dispatch(updatePatientSuccess(response.data));
      notify("Patient details updated successfully", "success");
      handleGetPatientById(updatedData?.local?.email);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      dispatch(updatePatientFailure());
      notify(getErrorStatement(error));
    }
  };

  return {
    handleGetPatient,
    handleUpdatePatient,
    handleGetPatientById,
  };
};

export default usePatient;
